import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleCheck } from 'lucide-react';
import { useMemo, useState } from 'react';
import { filterArtStylesByCategory, PROJECT_ART_STYLE_CATEGORIES, } from '@/entities/project/model/projectArtStyle';
import { assetManifest } from '@/shared/config/assetManifest';
/** 画面风格单选组的可访问名称。 */
const ART_STYLE_GROUP_LABEL = '画面风格';
/**
 * 渲染画面风格选择器：顶部分类标签 + 风格卡片网格。
 * 分类标签为胶囊分段控件，激活态使用品牌浅底与品牌文字；
 * 卡片缩略图取设计提供的风格模板图（assetManifest.artStyles），选中卡片展示品牌描边与勾选图标。
 */
export function ArtStylePicker(props) {
    /** 当前激活的分类标签，默认展示全部分类风格。 */
    const [activeCategory, setActiveCategory] = useState('all');
    /**
     * 分类标签项：名称与数量分列展示，便于创作者预估可选范围；
     * 数量由风格清单派生，清单调整后标签自动同步。
     */
    const categoryTabs = useMemo(() => PROJECT_ART_STYLE_CATEGORIES.map((category) => ({
        value: category.value,
        label: category.label,
        count: filterArtStylesByCategory(category.value).length,
    })), []);
    /** 当前分类下可见的风格卡片。 */
    const visibleStyles = filterArtStylesByCategory(activeCategory);
    /** 当前选中风格编码，未选择时用空字符串参与比较。 */
    const selectedValue = props.value ?? '';
    return (_jsxs("div", { className: "art-style-picker", children: [_jsx("div", { className: "art-style-picker__tabs", role: "group", "aria-label": "\u753B\u9762\u98CE\u683C\u5206\u7C7B", children: categoryTabs.map((tab) => {
                    /** 当前标签是否为激活分类，激活态使用品牌浅底与品牌文字。 */
                    const isActive = tab.value === activeCategory;
                    return (_jsxs("button", { type: "button", className: `art-style-picker__tab${isActive ? ' art-style-picker__tab--active' : ''}`, "aria-pressed": isActive, onClick: () => {
                            setActiveCategory(tab.value);
                        }, children: [_jsx("span", { className: "art-style-picker__tab-label", children: tab.label }), _jsx("span", { className: "art-style-picker__tab-count", children: tab.count })] }, tab.value));
                }) }), _jsx("div", { className: "art-style-picker__grid", role: "radiogroup", "aria-label": ART_STYLE_GROUP_LABEL, children: visibleStyles.map((style) => {
                    /** 当前卡片是否为选中风格。 */
                    const isSelected = style.value === selectedValue;
                    return (_jsxs("button", { type: "button", role: "radio", "aria-checked": isSelected, className: `art-style-card${isSelected ? ' art-style-card--selected' : ''}`, onClick: () => {
                            props.onChange?.(style.value);
                        }, children: [_jsxs("span", { className: "art-style-card__preview", children: [_jsx("img", { src: assetManifest.artStyles[style.value], alt: `${style.label}风格示意`, loading: "lazy" }), isSelected ? _jsx(CircleCheck, { className: "art-style-card__check" }) : null] }), _jsx("span", { className: "art-style-card__label", children: style.label })] }, style.value));
                }) })] }));
}
